export const PAYMENT_METHODS = {
  cashOrCard: 'cash_or_card',
  cashOnly: 'cash_only',
  cardOnline: 'card_online',
  online: 'online',
  fps: 'FPS',
};

export const CARD_ONLINE = {
  title: 'Онлайн-оплата',
  altTitle: 'Онлайн-оплата картой на сайте',
  subtitle: 'Удобный и безопасный способ оплаты заказа',
  value: PAYMENT_METHODS.cardOnline,
  icon: 'IconCard',
  altIcon: 'IconCardMethods',
};

export const FPS = {
  title: 'Система Быстрых Платежей',
  subtitle: 'Моментальный возврат средств при возврате товара',
  value: PAYMENT_METHODS.fps,
  icon: 'IconFPS',
}

export const CASH_OR_CARD = {
  title: 'Наличными или картой',
  altTitle: 'Наличными или картой при получении',
  subtitle: 'При получении в магазине или курьером',
  value: PAYMENT_METHODS.cashOrCard,
  icon: 'IconWallet',
  altIcon: ''
};

export const CASH_ONLY = {
  title: 'Наличными',
  subtitle: 'При получении в магазине или курьером',
  value: PAYMENT_METHODS.cashOnly,
  icon: 'IconCash',
  altIcon: ''
};

export const ACTIVE_PAYMENT_METHODS = [
  CARD_ONLINE,
  FPS,
  CASH_OR_CARD,
  CASH_ONLY,
];
